// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"768":"9f9085d1","4015":"9f9085d1","7644":"9f9085d1"}[chunkId] + ".chunk.css";
};